import { Autocomplete, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../redux/types'

interface IBrand {
  id: number
  name: string
}

interface BrandAutocompleteProps {
  value: number[]
  handleInputChange: (inputName: string, value: any) => void
  familyId?: number
}

function BrandAutocomplete({ value, handleInputChange, familyId }: BrandAutocompleteProps) {
  const { t } = useTranslation(['global'])
  const { userBrands } = useSelector((state: IRootState) => state.brand)

  const handleMultiAutoCompleteChange = (brands: IBrand[]) => {
    let optionsMulti: number[] = []
    if (brands !== null) {
      for (let i = 0; i < brands.length; i++) {
        optionsMulti.push(brands[i].id)
      }
    }

    handleInputChange('brands', optionsMulti)
  }

  return (
    <Autocomplete
      id="combo-box-brands"
      ChipProps={{ color: 'secondary' }}
      value={userBrands.filter((brand: any) => value.includes(brand.id))}
      onChange={(_, value) => handleMultiAutoCompleteChange(value)}
      options={familyId ? userBrands.filter((brand: any) => brand.family_id === familyId) : userBrands}
      multiple
      getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
      renderInput={params => (
        <TextField {...params} label={t('brands')} variant="filled" InputLabelProps={{ shrink: true }} />
      )}
    />
  )
}

export default BrandAutocomplete
